// src/v2/hooks/useUploadingSchedule.js
import { useState, useCallback, useEffect } from "react";
import { uploadingScheduleService } from "../services/uploadingScheduleService";

export const useUploadingSchedule = ({ showGeneralMessage, apiFilterPayload }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);

  const fetchData = useCallback(async () => {
    // MODIFIED: Ensure we have the required filter before calling API
    if (!apiFilterPayload.PayrollPeriodId) {
      setData([]);
      setOriginalData([]);
      setDateRange([]);
      return;
    }

    setLoading(true);
    try {
      // REPLACED: Removed shiftRes from here as it's now handled by useShiftSchedules
      const res = await uploadingScheduleService.getSchedulePreview(apiFilterPayload);

      setData(res.data.employees || []);
      setOriginalData(res.data.employees || []);
      setDateRange(res.data.dateRange || []);
    } catch (err) {
      console.error(err);
      showGeneralMessage("Failed to load schedules", false);
    } finally {
      setLoading(false);
    }
  }, [apiFilterPayload, showGeneralMessage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleCellChange = (employeeId, day, shiftId) => {
    setData(prev => prev.map(emp => {
      if (emp.id === employeeId) {
        return {
          ...emp,
          schedules: { ...emp.schedules, [day]: shiftId }
        };
      }
      return emp;
    }));
  };

  const handleSearch = (value) => {
    if (!value || value.trim() === "") {
      setData(originalData);
      return;
    }
    const lower = value.toLowerCase();
    const filtered = originalData.filter(emp =>
      emp.fullName?.toLowerCase().includes(lower) ||
      emp.employeeId?.toString().toLowerCase().includes(lower)
    );
    setData(filtered);
  };

  const saveChanges = async () => {
    setLoading(true);
    try {
      await uploadingScheduleService.saveSchedules({
        employees: data,
        payrollPeriodId: apiFilterPayload.PayrollPeriodId
      });
      showGeneralMessage("Schedules saved successfully", true);
      setEditingRowId(null);
      fetchData();
    } catch (err) {
      showGeneralMessage("Failed to save changes", false);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    data,
    dateRange,
    editingRowId,
    setEditingRowId,
    handleSearch,
    handleCellChange,
    saveChanges,
    refresh: fetchData
  };
};